import React from 'react';
import { DialogContent, Grid, Typography, TextField, List, ListItem, Button, FormControl, FormControlLabel, Link, Switch, makeStyles } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';

import classNames from 'classnames';
import FacebookLogoDisabled from '../../resources/facebookIconDisabled.png';
import TwitterLogoDisabled from '../../resources/twitterLogoDisabled.png';
import { useSharingDialog } from './SharingDialog';

const useStyles = makeStyles((theme) => ({
    listItemSubContainer: {
        textAlign: 'center'
    },
    disabledAnchor: {
        pointerEvents: 'none',
        cursor: 'default',
        color: "#b4b4b4"
    },
    socialIcons: {
        width: 40,
        height: 40,
        marginTop: -5
    },
    disabledButton: {
        backgroundColor: '#a7a7a7',
    },
    disabledText: {
        color: "#a7a7a7",
        pointerEvents: "none",
        cursor: "default"
    },
    urlInput: {
        maxHeight: 51,
        borderRadius: '0px',
        fontSize: '12px',
        [`& fieldset`]: {
            borderRadius: 0,
        }
    },
    listHorizontal: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
    },
    listItem: {
        width: 70,
        "&:nth-of-type(2)": {
            width: 95
        }
    },
    mobileFormLabel: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        },
    },
    switchLabel: {
        fontWeight: 500,
        fontSize: 16
    },
    copyButton: {
        width: '100%',
        height: 51,
        backgroundColor: '#5bb2f6',
        marginBottom: 8,
        color: '#FFF',
        textAlign: 'center',
        verticalAlign: 'middle',
        "& span": {
            display: 'inline-block',
            marginTop: 16
        },
        cursor: 'pointer',

    },
}));

export function RenderUnsharedContent(){
    const classes = useStyles();
    const { sharedItem, sharedUrl } = useSharingDialog();
    
    return (
        <DialogContent style={{ width: "100%" }}>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <Typography style={{ marginBottom: 8 }} className={classes.disabledText} variant="subtitle2">Link for sharing</Typography>
                </Grid>
                <Grid item xs={9}>
                    <TextField
                        id="url"
                        value={sharedUrl}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            className: classNames(classes.urlInput, classes.disabledText),
                            id: "urlInput",
                            disabled: true
                        }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={3}>
                    <div className={classNames(classes.copyButton, classes.disabledButton)} style={{ cursor: 'default', pointerEvents: 'none' }}>
                        <span>COPY LINK</span>
                    </div>
                </Grid>
            </Grid>
            <hr />
            <Typography style={{ marginBottom: 8, marginTop: 12 }} className={classes.disabledText} variant="subtitle2">More sharing options</Typography>
            <div style={{ maxWidth: 300 }}>
                <List className={classes.listHorizontal}>
                    <ListItem className={classes.listItem}>
                        <div className={classes.listItemSubContainer}>
                            <EmailIcon fontSize="large" style={{ color: "#b4b4b4" }} />
                            <Link component="button" className={classes.disabledAnchor}>Email</Link>
                        </div>
                    </ListItem>
                    <ListItem className={classes.listItem}>
                        <div className={classes.listItemSubContainer}>
                            <img alt="Facebook" className={classes.socialIcons} src={FacebookLogoDisabled} />
                            <Link component="button" className={classes.disabledAnchor}>Facebook</Link>
                        </div>
                    </ListItem>
                    <ListItem className={classes.listItem}>
                        <div className={classes.listItemSubContainer}>
                            <img alt="Twitter" className={classes.socialIcons} src={TwitterLogoDisabled} />
                            <Link component="button" className={classes.disabledAnchor}>Twitter</Link>
                        </div>
                    </ListItem>
                </List>
            </div>
            {
                (sharedItem.videoPath && sharedItem.videoPath.length > 0) ?
                    <div style={{ marginBottom: 20 }}>
                        <Typography style={{ marginBottom: 8 }} className={classes.disabledText}  variant="subtitle2">Your video message</Typography>
                        <div>
                            <div>
                                <Button style={{ width: 120 }} disabled={true} size="small" variant="contained" color="primary">
                                    Change Video
                                </Button>
                                &nbsp;
                                <Button style={{ width: 120 }} disabled={true} size="small" variant="contained" color="primary">
                                    Remove Video
                                </Button>
                            </div>
                        </div>
                    </div> :
                    <div style={{ marginBottom: 20 }}>
                        <Typography style={{ marginBottom: 8 }} className={classes.disabledText} variant="subtitle2">Your video message&nbsp;<a className={classes.disabledAnchor}href="https://sermonmaker.sermon.stream/share-your-video" target="_blank" rel="noreferrer">See an example</a></Typography>
                        <div>
                            <div>
                                <Button style={{ width: 120 }} disabled={true} size="small" variant="contained" color="primary">
                                    Add a Video
                                </Button>
                            </div>
                        </div>
                    </div>
            }
            <Typography style={{ marginBottom: 8 }} className={classes.disabledText} variant="subtitle2">Your shared page</Typography>
            <div>
                <div>
                    <Link component="button" className={classes.disabledAnchor}>
                        <Button style={{ width: 120 }} disabled={true} size="small" variant="contained" color="primary">
                            Preview
                        </Button>
                    </Link>
                </div>
            </div>
            <FormControl style={{ marginTop: 16 }}>
                <FormControlLabel
                    style={{ marginLeft: 0 }}
                    label={`Comments are ${sharedItem.commentsEnabled ? "on" : "off"}`}
                    className={classes.mobileFormLabel}
                    control={
                        <Switch
                            disabled={true}
                            style={{ height: 20 }}
                            checked={sharedItem.commentsEnabled}
                            value="Share"
                            color="primary"
                        />
                    }
                    classes={{ label: classes.switchLabel }}
                    labelPlacement="start"
                />
            </FormControl>
        </DialogContent>
    );
}